<div class="row">
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a
        class="nav-link"
        [ngClass]="{
          'text-muted': showAllDocuments,
          'bergh-text-primary': !showAllDocuments,
          active: !showAllDocuments
        }"
        (click)="showAllDocuments = false"
        >Toon gelinkte documenten</a
      >
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        [ngClass]="{
          'text-muted': !showAllDocuments,
          'bergh-text-primary': showAllDocuments,
          active: showAllDocuments
        }"
        (click)="showAllDocuments = true"
        >Toon alle projectdocumenten</a
      >
    </li>
  </ul>
  @if (showAllDocuments) {
  <table class="table table-striped w-100 mt-3">
    @if (this.allDocuments.length==0) {
    <div class="alert alert-info">Geen projectdocumenten alle</div>
    } @if (this.allDocuments.length>0) {
    <tbody>
      @for (document of allDocuments; track document) {
      <tr>
        <td>
          <a target="_blank" href="{{ document?.url }}">{{
            document?.filename
          }}</a>
        </td>
        <td>
          {{ document.createdAt | date : "dd-MM-yyyy hh:mm" }}
        </td>
        @if (!isSealPage && !isCustomer) {
        <td class="text-right">
          @if (!document.linked) {
          <i-feather
            class="feather-icon-custom-class"
            name="link"
            (click)="linkDocumentWithFirePartition(document._id)"
          ></i-feather>
          } @if (document.linked) {
          <i-feather
            class="feather-icon-custom-class"
            name="file-minus"
            (click)="unlinkDocumentWithFirePartition(document._id)"
          ></i-feather>
          }
        </td>
        }
      </tr>
      }
    </tbody>
    }
  </table>
  } @if (!showAllDocuments) {
  <table class="table table-striped w-100 mt-3">
    @if (this.linkedDocuments.length==0) {
    <div class="alert alert-info">Geen documenten gelinkt</div>
    } @if (this.linkedDocuments.length>0) {
    <tbody>
      @for (document of linkedDocuments; track document) {
      <tr>
        <td>
          <a target="_blank" href="{{ document?.url }}">{{
            document?.filename
          }}</a>
        </td>
        <td>
          {{ document?.createdAt | date : "dd-MM-yyyy hh:mm" }}
        </td>
        @if (!isSealPage && !isCustomer) {
        <td class="text-right">
          <i-feather
            class="feather-icon-custom-class"
            name="file-minus"
            (click)="unlinkDocumentWithFirePartition(document._id)"
          ></i-feather>
        </td>
        }
      </tr>
      }
    </tbody>
    }
  </table>
  }
</div>
